import React, { memo } from 'react';

import { Block } from '../../components/core';
import { RollingCorrelationHeader } from './rolling-correlation-header';
import { RollingCorrelationContent } from './rolling-correlation-content';

import { MetricsErrorWrapper } from '../../../studio-blocks/components/error-wrappers/MetricsErrorWrapper';
import { COMMON_ERROR_WRAPPERS } from '../../../studio-blocks/components/error-wrappers/common';
import { NoMetricsErrorWrapper } from '../../../studio-blocks/components/error-wrappers/NoMetricsErrorWrapper';

interface RollingCorrelationBlockProps {
  id: string;
}

export const RollingCorrelationBlock = memo(function InternalRollingCorrelationBlock({
  id,
}: RollingCorrelationBlockProps) {
  return (
    <Block.Root id={id}>
      <Block.Header>
        <RollingCorrelationHeader id={id} />
      </Block.Header>

      <Block.Content id={id} errorWrappers={[...COMMON_ERROR_WRAPPERS, NoMetricsErrorWrapper, MetricsErrorWrapper]}>
        <RollingCorrelationContent id={id} />
      </Block.Content>
    </Block.Root>
  );
});
